// Coffee is light-only, so the placeholder is always the light image.
// The function/hook signatures are kept so existing callers need no change.
export const COFFEE_LIGHT_PLACEHOLDER = '/coffee/light_coffee_placeholder.jpg';
export const COFFEE_DARK_PLACEHOLDER = '/coffee/dark_coffee_placeholder.jpg';

export function getCoffeePlaceholderSrc() {
  return COFFEE_LIGHT_PLACEHOLDER;
}

export function useCoffeePlaceholderSrc() {
  return COFFEE_LIGHT_PLACEHOLDER;
}
